import jsPDF from 'jspdf';
import moment from 'moment';
import rareLogo from '../img/rareLogo';
import summaryImg from '../img/summaryImg';
import { store } from '../../store/store';
import {
  calcBarWidth,
  calculateCategoryDataX,
  calculateTitleXOffset,
  formatFlagBreakdownData,
  generatePDFfileName,
  hex2rgb,
  parseSummaryArray,
} from './js/functions';

export default function summaryPDFexportOneComp() {
  const page = 'summary';
  const { dataFormat } = store.getters;
  const flagBreakDownData = {};
  const chartWidth = 275;
  const singleMetricDataX = 310;
  const filename = generatePDFfileName();
  const fromDate = moment(store.getters.fromDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
  const toDate = moment(store.getters.toDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
  const totalApplications = store.getters.totalApplicationsBase;
  const { currentClient } = store.getters;
  const title = store.getters.getDisplayNameFromUsername(currentClient);
  const textColors = store.getters.fetchTextColors;
  const barColors = store.getters.fetchBarColors;
  const barBaseColor = hex2rgb(barColors[0]);
  const textBaseColor = hex2rgb(textColors[0]);
  const dataX = 550;

  let sectionY = 270;
  let dataY = 223;
  let titleY;
  let chartY;

  function moveYdownTitle(points = 26) {
    const newValue = chartY + points;
    titleY = newValue;
    return newValue;
  }

  function moveYdownChart(points = 5) {
    const newValue = titleY + points;
    chartY = newValue;
    return newValue;
  }

  flagBreakDownData.baseDataDate = store.getters['$_summary/getSummaryFlagBreakDownData']({
    type: 'Base',
    dataFormat,
  });
  flagBreakDownData.comparisonDataDate = store.getters['$_summary/getSummaryFlagBreakDownData']({
    type: 'Comparison',
    dataFormat,
  });

  const legendDataArray = store.getters.legendData;

  const OnePlusFlagData = parseSummaryArray(store.getters['$_summary/getSummaryOnePlusFlagData'](dataFormat));
  const SocioeconomicFlagData = parseSummaryArray(store.getters['$_summary/getSummaryCategoryData']({
    type: 'Socioeconomic flags',
    dataFormat,
  }));
  const SocioeconomicFlagFirsGenUniData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'First Gen',
    dataFormat,
  }));
  const SocioeconomicFlagFreeSchoolMealsData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'FSM',
    dataFormat,
  }));
  const SocioeconomicFlagPostcodeData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'Disadvantaged postcode',
    dataFormat,
  }));
  const SocioeconomicFlagUniWorkData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'Uni Term Work',
    dataFormat,
  }));
  const SocioeconomicFlagSchoolWorkData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'School Term Work',
    dataFormat,
  }));
  const AcademicFlagData = parseSummaryArray(store.getters['$_summary/getSummaryCategoryData']({
    type: 'Academic flags',
    dataFormat,
  }));
  const AcademicFlagBottom40Data = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'Bottom 40% school',
    dataFormat,
  }));
  const AcademicFlagBottom10Data = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'Bottom 10% school',
    dataFormat,
  }));
  const PersonalFlagData = parseSummaryArray(store.getters['$_summary/getSummaryCategoryData']({
    type: 'Personal flags',
    dataFormat,
  }));
  const PersonalRefugeeData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'Refugee/Asylum seeker',
    dataFormat,
  }));
  const PersonalInCareData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'In care',
    dataFormat,
  }));
  const PersonalCarerData = parseSummaryArray(store.getters['$_summary/getSummarySingleMetricData']({
    type: 'Carer/Parent',
    dataFormat,
  }));

  const doc = new jsPDF(
    {
      orientation: 'p',
      unit: 'pt',
      format: 'a4',
    },
  );

  doc.setFont('helvetica');

  // Header with logo and client name
  doc.setFillColor(50, 60, 68);
  doc.rect(20, 20, 555, 50, 'F');
  doc.addImage(rareLogo, 'PNG', 30, 33, 138, 24);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text(title, calculateTitleXOffset(title), 50);

  // Sub-header with  divider lines and "SUMMARY" header
  doc.setDrawColor(221, 221, 221);
  doc.setLineWidth(1);
  doc.line(20, 125, 575, 125);
  doc.addImage(summaryImg, 'PNG', 22, 90, 111, 17);
  doc.line(20, 165, 575, 165);

  // Dates and total apps section to the right
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.text(397, 91, 'Date Range:');
  doc.text(397, 109, 'Report based on:');
  doc.setFont('helvetica', 'normal', 'bold');
  doc.text(460, 91, `${fromDate} - ${toDate}`);
  doc.text(480, 109, `${totalApplications} applications`);

  // THE LEGEND SECTION
  // Current client
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.setFillColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.circle(25, 145, 4, 'F');
  doc.text(38, 148, legendDataArray[0]);

  // Set text styles for the rest of the export
  doc.setTextColor(50, 60, 68);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal', 'normal');

  // Flag Breakdown column
  doc.text(350, 205, 'FLAG BREAKDOWN');
  doc.line(350, 220, 570, 220);
  doc.addImage(window.summaryFlagBreakdownChartImg, 'PNG', 350, 230, 200, 170);
  doc.line(350, 410, 570, 410);

  // Loop through and insert data for Flag Breakdown chart.
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');
  for (let i = 0; i < 6; i += 1) {
    dataY += 27;
    doc.setTextColor(50, 140, 161);
    doc.text(dataX, dataY, formatFlagBreakdownData(flagBreakDownData.baseDataDate[0][i]));
  }

  // One plus flag chart
  doc.setTextColor(50, 60, 68);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, 205, '1+ FLAG APPLICATIONS');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, 220, calcBarWidth(OnePlusFlagData.base, chartWidth, page), 28, 'F');

  // Insert data for One Plus Flag chart.
  doc.setFont('helvetica', 'normal', 'normal');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(292, 240, OnePlusFlagData.baseLabel);

  // Socioeconomic section
  doc.line(20, sectionY, 340, sectionY);

  doc.setTextColor(74, 91, 104);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, sectionY += 28, 'SOCIOECONOMIC FLAG');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, sectionY += 9, calcBarWidth(SocioeconomicFlagData.base, chartWidth, page), 19, 'F');

  // Insert data forSocioeconomic Flag chart.
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(calculateCategoryDataX(SocioeconomicFlagData.baseLabel), sectionY += 13, SocioeconomicFlagData.baseLabel); // eslint-disable-line

  doc.setTextColor(50, 60, 68);
  doc.setFontSize(10);

  sectionY += 29;
  titleY = sectionY;
  sectionY += 8;
  chartY = sectionY;

  // Socioeconomic Flag -  First Gen Uni Data
  doc.setTextColor(74, 91, 104);
  doc.setFont('helvetica', 'normal', 'bold');
  doc.text(20, titleY, 'First Generation at University');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, chartY, calcBarWidth(SocioeconomicFlagFirsGenUniData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagFirsGenUniData.baseLabel);

  // Socioeconomic Flag - Free School Meals Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Free School Meals');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagFreeSchoolMealsData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagFreeSchoolMealsData.baseLabel);

  // Socioeconomic Flag - Postcode Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Disadvantaged Postcode');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagPostcodeData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagPostcodeData.baseLabel);

  // Socioeconomic Flag - Uni Work Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'University Term Work');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagUniWorkData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagUniWorkData.baseLabel);

  // Socioeconomic Flag - School Work Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'School Term Work');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagSchoolWorkData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagSchoolWorkData.baseLabel);

  sectionY = 507;

  // ACADEMIC SECTION
  doc.line(20, sectionY, 340, sectionY);
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, sectionY += 28, 'ACADEMIC FLAG');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, sectionY += 9, calcBarWidth(AcademicFlagData.base, chartWidth, page), 19, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(calculateCategoryDataX(AcademicFlagData.baseLabel), sectionY += 13, AcademicFlagData.baseLabel); // eslint-disable-line

  doc.setTextColor(50, 60, 68);
  doc.setFontSize(10);

  sectionY += 29;
  titleY = sectionY;
  sectionY += 8;
  chartY = sectionY;

  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');

  // Academic Flag - Bottom 40%
  doc.text(20, titleY, 'Bottom 40% school');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, chartY, calcBarWidth(AcademicFlagBottom40Data.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, AcademicFlagBottom40Data.baseLabel);

  // Academic Flag - Bottom 10%
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Bottom 10% school');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(AcademicFlagBottom10Data.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, AcademicFlagBottom10Data.baseLabel);

  sectionY = 657;
  doc.line(20, sectionY, 340, sectionY);
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, sectionY += 28, 'PERSONAL FLAG');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, sectionY += 9, calcBarWidth(PersonalFlagData.base, chartWidth, page), 19, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(calculateCategoryDataX(PersonalFlagData.baseLabel), sectionY += 13, PersonalFlagData.baseLabel); // eslint-disable-line

  doc.setTextColor(50, 60, 68);
  doc.setFontSize(10);

  sectionY += 29;
  titleY = sectionY;
  sectionY += 8;
  chartY = sectionY;

  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');

  // Personal Flag -  Refugee Data
  doc.text(20, titleY, 'Refugee/Asylum seeker');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, chartY, calcBarWidth(PersonalRefugeeData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, PersonalRefugeeData.baseLabel);

  // Personal Flag - In Care Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'In care');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(PersonalInCareData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, PersonalInCareData.baseLabel);

  // Personal Flag - Parent/Carer Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Carer/Parent');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(PersonalCarerData.base, chartWidth, page), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, PersonalCarerData.baseLabel);

  // Page x of y at the bottom of the page
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(515, 820, 'Page 1 of 1');
  doc.save(filename);
}
